import React, { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'

import { Query } from 'graphqlAPI'
import { ChildFilterTypes } from 'enum'
import { ApplyFiltersByType } from '../types'
import { GeneralProgress } from './GeneralProgress'

const GLOBAL_ADVANCEMENT = gql`
  query GlobalAdvancement($usersAllCourseRansack: JSON) {
    globalAdvancement {
      coursesCount
      hoursTotal
      participantsCount(ransack: $usersAllCourseRansack)
      coursesProgress(ransack: $usersAllCourseRansack) {
        finish
        inProgress
        pending
      }
    }
  }
`

interface GlobalProgressProps {
  applyFiltersByType: ApplyFiltersByType
}

export const GlobalProgress: React.FC<GlobalProgressProps> = ({
  applyFiltersByType,
}) => {
  const g = useMemo(
    () => applyFiltersByType(ChildFilterTypes.Participant),
    [applyFiltersByType]
  )

  const { loading, data } = useQuery<
    Pick<Query, 'globalAdvancement' | '__typename'>,
    {
      usersAllCourseRansack: { g: any }
    }
  >(GLOBAL_ADVANCEMENT, {
    variables: {
      usersAllCourseRansack: {
        g: g.filters,
      },
    },
    fetchPolicy: 'cache-and-network',
  })

  const globalAdvancement = data?.globalAdvancement

  return (
    <GeneralProgress
      data={
        globalAdvancement
          ? {
              coursesProgress: globalAdvancement.coursesProgress,
              participantsCount: globalAdvancement.participantsCount,
              coursesCount: globalAdvancement.coursesCount,
            }
          : undefined
      }
      loading={loading}
    />
  )
}
